import {actions} from 'mirrorx';
import localforage from 'localforage';

class LocalhostController {
	maxItems = 10;
	save(text, filename) {
		return localforage.setItem(filename, text);
	}
	load(filename) {
		return localforage.getItem(filename).then(text => {
			actions.editor.updateText(text || '');
			return new Promise((resolve, reject) => {
				resolve();
			});
		})
	}
	delete(filename) {
		return localforage.removeItem(filename);
	}
	saveRecentPaths(array) {
		return localforage.setItem('rune-recent-items', array);
	}
	loadRecentPaths() {
		return localforage.getItem('rune-recent-items');
	}
}

export default LocalhostController;


// WEBPACK FOOTER //
// ./src/controllers/localhost-controller.js